import { render, staticRenderFns } from "./CustomersDistributionGraph.vue?vue&type=template&id=00242588"
import script from "./CustomersDistributionGraph.vue?vue&type=script&lang=js"
export * from "./CustomersDistributionGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports